export function isAegisEmbedUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) return false;
  return (
    /aegis\.ai-vai\.com\/embed\/podcast\//i.test(raw) ||
    /aegis\.ai-vai\.com\/(?:api\/v1\/)?player-sdk\/audio-player\.html/i.test(raw)
  );
}

export function resolveAegisPlayerUrl(source = {}) {
  const raw = source && typeof source === "object" ? source : {};
  const candidates = [
    raw.aegisPlayerUrl,
    raw.aegis_player_url,
    raw.aegisEmbedUrl,
    raw.aegis_embed_url,
    raw.playerUrl,
    raw.player_url,
    raw.playbackUrl,
    raw.playback_url,
    raw.embedUrl,
    raw.embed_url,
    raw.externalUrl,
    raw.external_url,
  ];

  for (const candidate of candidates) {
    const url = String(candidate || "").trim();
    if (isAegisEmbedUrl(url)) return url;
  }

  return "";
}
